/*
 * description: iframe内嵌通信【父级】
 * */

export const createMessageChannel = ({ origin, namespace }) => {
    const _eventMap = new Map()
    let _source

    const _handler = e => {
        if (origin && origin !== '*' && e.origin !== origin) return

        const { eventName, eventData, namespace: _namespace } = e.data || {}

        if (namespace && _namespace && namespace === _namespace) {
            _source = e.source

            if (_eventMap.has(eventName)) {
                _eventMap.get(eventName).forEach(fn => fn(eventData, e))
            }
        }
    }

    const _attachEvent = (eventName, handler) => {
        if (_eventMap.has(eventName)) {
            const queue = _eventMap.get(eventName).filter(fn => fn !== handler)

            queue.push(handler)

            _eventMap.set(eventName, queue)
        } else {
            _eventMap.set(eventName, [handler])
        }
    }

    // 接收消息
    const receiveMessage = (eventName, handler) => {
        _attachEvent(eventName, handler)
    }

    // 移除监听
    const removeListen = (eventName, handler) => {
        if (_eventMap.has(eventName)) {
            _eventMap.set(
                eventName,
                _eventMap.get(eventName).filter(fn => fn !== handler)
            )
        }
    }

    // 发送消息至子窗口
    const postMessage = (eventName, eventData) => {
        if (!_source) {
            return
        }
        _source.postMessage({ eventName, eventData, namespace }, origin)
    }

    // 关闭
    const close = () => {
        window.removeEventListener('message', _handler, false)
        _source = null
        _eventMap.clear()
    }

    window.addEventListener('message', _handler, false)

    return {
        receiveMessage,
        postMessage,
        removeListen,
        close
    }
}
